<app-home-infobox></app-home-infobox>

<footer class="footer">
  <!-- Main footer body -->
  <div class="footer-body">
    <div class="container">
      <div class="row">

        <!-- Brand column -->
        <div class="col-sm-6 col-md-6">
          <div class="footer-item">
            <img src="/assets/images/footer-logo.png" alt="CDC Logo" class="logo-bottom">

            <p class="footer-desc" [innerHTML]="'General_Footer_CDC_CR' | translate"></p>

            <div class="footer-sosmed">
              <a href="https://carteldamageclaims.com/" target="_blank" rel="noopener" title="Website">
                <span class="sosmed-item">
                  <i class="fa-solid fa-store"></i>
                </span>
              </a>

              <a href="https://x.com/C_D_C_Brussels" target="_blank" rel="noopener" title="X / Twitter">
                <span class="sosmed-item">
                  <i class="fa-brands fa-x-twitter"></i>
                </span>
              </a>

              <a href="https://www.linkedin.com/company/cartel-damage-claims-cdc-?originalSubdomain=be"
                 target="_blank" rel="noopener" title="LinkedIn">
                <span class="sosmed-item">
                  <i class="fa-brands fa-linkedin-in"></i>
                </span>
              </a>
            </div>
          </div>
        </div>

        <!-- Services column -->
        <div class="col-sm-6 col-md-6">
          <div class="footer-item">
            <div class="footer-title">
              {{'General_OurServices' | translate}}
            </div>

            <ul class="footer-list">
              <li *ngFor="let item of serviceList">
                <a [routerLink]="['/pages/services/' + item.id]" [matTooltip]="item.title | translate">
                  <i class="fa-solid fa-chevron-right footer-list-arrow"></i>
                  {{item.title | translate}}
                </a>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Copyright bar -->
  <div class="fcopy">
    <div class="container">
      <div class="fcopy-inner">
        <span [innerHTML]="'General_Footer_CDC_CR' | translate"></span>
        <div class="fcopy-links">
          <a href="https://carteldamageclaims.com/" target="_blank" rel="noopener">
            <i class="fa-solid fa-store"></i>
          </a>
          <a href="https://x.com/C_D_C_Brussels" target="_blank" rel="noopener">
            <i class="fa-brands fa-x-twitter"></i>
          </a>
          <a href="https://www.linkedin.com/company/cartel-damage-claims-cdc-?originalSubdomain=be"
             target="_blank" rel="noopener">
            <i class="fa-brands fa-linkedin-in"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>
